import { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { FlexRow, Grid, BaseCol } from '../containers/flexbox_layout/FlexboxGrid';
import { Styles } from '..';

const HeaderWrapper = styled.div`
  max-width: 1920px;
  padding: 0 20px;
  margin: 0 auto;
  clear: both;
`;;

const HeaderMainCol = styled(BaseCol)`
  @media screen and (min-width: 769px) {
    width: 70%;
    max-width: 70%;
    flex-basis: 70%;
  }
`;

const HeaderActionsCol = styled(BaseCol)`
  @media screen and (min-width: 769px) {
    max-width: 30%;
  }
  @media screen and (max-width: 768px) {
    border-top: 1px dotted ${Styles.colors.grey.secondaryDark};
    padding-left: 0;
    margin-top: ${(props) => props.compactHeader ? "0px" : "22px"};
  }
`;

export function MultiPaneHeader({ children, compactHeader }) {
  if (children.length !== 2) {
    throw Error('ContentHeader requires 2 children: main, and actions.');
  }

  const [Main, Actions] = Children.toArray(children);

  const mainAlignProps = { sm: 12, md: 6, align: 'left' };
  const actionsAlignProps = { sm: 12, md: 6, pad: { left: 'small' }, align: 'right' };
  return (
    <HeaderWrapper>
      <Grid>
        <FlexRow>
          <HeaderMainCol compactHeader={compactHeader} {...mainAlignProps}>{cloneElement(Main)}</HeaderMainCol>
          <HeaderActionsCol compactHeader={compactHeader} {...actionsAlignProps}>{cloneElement(Actions)}</HeaderActionsCol>
        </FlexRow>
      </Grid>
    </HeaderWrapper>
  );
}

MultiPaneHeader.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};
